<template>
	<resources-index :resources="resources" type="intermission" plural="intermissions"></resources-index>
</template>

<script>

import ResourcesIndex from '@/views/resources/Index'
import {sync} from "vuex-pathify";
export default {
	name: "IntermissionIndex",
	components: {
		ResourcesIndex
	},
	computed: {
		resources: sync('intermissions/intermissions'),
	},
}
</script>